const appointmentStatus = {
    Coordinada:1,
    Cancelada_DE:2,
    Cancelada_Prov:3,
    Completada:4,
    Aprobada:5,
    Denegada:6,
    Extendida:8,
    Confirmada:9,
    Denied:10,
    Adjustment:11,
    Absence:12,
    Cumplida:14
};
  
export default appointmentStatus;